$(function () {
    'use strict';

    var $buttons = $('.firm-request-button');

    $buttons.on('click', function(e) {
        e.preventDefault();
        var $button = $(this);
        var isRequested = $button.data('isRequested');
        if (isRequested) {
            Toasts.pushToast('Вы уже отправили запрос', 'fail');
            return false;
        }

        var userId = $button.data('userId');
        var requestType = $button.data('requestType');
        if (!userId || !requestType) {
            Toasts.pushToast('Произошла ошибка, попробуйте повторить позднее', 'fail');
            return false;
        }

        var url = $button.data('requestUrl');
        $.ajax({
            url: url,
            cache: false,
            method: 'POST',
            data: {
                'request_type': requestType,
                'user_id': userId
            }
        })
            .done(function(data) {
                $button.data('isRequested', true);
                Toasts.pushToast('Запрос успешно отправлен', 'success');
            })
            .fail(function() {
                Toasts.pushToast('Что-то пошло не так. Попробуйте повторить попытку.', 'fail');
            })
        ;
    });
});